export const getRoleOwnersUrl = () => "/admin/role-owner";
